import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mto_option_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  image_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  is_default: boolean;
  currency: fromDatatype.VarcharDatatypeInterface;
  unit_price: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  mto_component_guid: fromDatatype.VarcharDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface; 
  negation_logic: boolean;
  auto_add_qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_mto_option_line_RowClass implements bl_fi_mto_option_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  image_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  is_default: boolean;
  currency: fromDatatype.VarcharDatatypeInterface;
  unit_price: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  mto_component_guid: fromDatatype.VarcharDatatypeInterface;
  quantity: fromDatatype.NumericDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface; 
  negation_logic: boolean;
  auto_add_qty: fromDatatype.NumericDatatypeInterface;
}
